/** Shopify rejects a products query asking for more than this in one page. */
export const PLATFORM_PRODUCTS_MAX_PAGE_SIZE = 250;

/**
 * Prefix of every `usePlatformProductsQuery` key (`['PlatformProducts', variables]`), for callers
 * invalidating the query without holding its variables. Matches the operation name in
 * `platformProducts.gql`, which is what codegen builds the key from.
 */
export const PLATFORM_PRODUCTS_QUERY_KEY = 'PlatformProducts';
